import Vue from 'vue'
import CDialog from './CDialog.vue'
import CSnackbar from './CSnackbar.vue'

Vue.component('CDialog', CDialog)
Vue.component('CSnackbar', CSnackbar)
